import React, { useMemo } from 'react';
import { evaluatePasswordStrength, MIN_PASSWORD_SCORE } from './passwordStrength.js';

const BAR_COLORS = [
  'bg-red-500',
  'bg-orange-500',
  'bg-yellow-500',
  'bg-dp-green',
  'bg-emerald-400',
];

export default function PasswordStrengthMeter({ password, className = '' }) {
  const result = useMemo(() => evaluatePasswordStrength(password), [password]);

  if (!password) return null;

  return (
    <div className={`space-y-2 ${className}`} aria-live="polite">
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="vault-text-muted">Passwortstärke</span>
        <span className={result.acceptable ? 'text-dp-green font-medium' : 'vault-text-danger font-medium'}>
          {result.label}
        </span>
      </div>
      <div className="h-1.5 w-full vault-progress-track rounded-full overflow-hidden" role="meter"
        aria-valuenow={result.score}
        aria-valuemin={0}
        aria-valuemax={4}
        aria-label={`Passwortstärke: ${result.label}`}
      >
        <div
          className={`h-full transition-all duration-200 rounded-full ${BAR_COLORS[result.score] || BAR_COLORS[0]}`}
          style={{ width: `${result.barPercent}%` }}
        />
      </div>
      <ul className="text-xs vault-text-muted space-y-1 list-disc list-inside leading-relaxed">
        {result.feedback.map((line) => (
          <li key={line}>{line}</li>
        ))}
        {!result.acceptable && result.score < MIN_PASSWORD_SCORE && password.length >= 12 && (
          <li>Mindeststärke: „Gut“ (Score {MIN_PASSWORD_SCORE}/4).</li>
        )}
      </ul>
      <p className="text-[11px] vault-text-muted">
        Diese Prüfung läuft in Ihrem Browser gegen eine mitgelieferte Liste. Ihr Passwort
        wird dabei nirgendwo hingeschickt.
      </p>
    </div>
  );
}
